// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"871":"2e1ec5ec","939":"36648643","975":"c781e0e8","989":"508c3f8d"}[chunkId] + ".js";
};